import * as pubnubService from '@/services/pubnubService';
import { getBidderHasHighBid, getBidSource } from './liveBid';
import { getBidderId } from './user';
import { getItem } from './item';
import { getPubnubPublishKey } from './console';
import { isItemSaved } from './saveItem';
import { isSellerFollowed } from './followSeller';

/* ACTIONS CREATORS */
export const sendHoverMessage = (
    actionTime: number,
    catalogId: number,
    currentAskPrice: number,
    currency: string,
    itemId: number
) => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const created = new Date(actionTime).toISOString();
        const BidderId = getBidderId(state);
        const hasHighBid = getBidderHasHighBid(state);
        const publishKey = getPubnubPublishKey(state, catalogId);
        const isSaved = isItemSaved(state, itemId);
        const item = getItem(state, itemId);
        const isFollowed = isSellerFollowed(state, item.sellerId);
        const BidSource = getBidSource(state);

        // Throw an error if we are missing info for bidding or the bidderid is -1
        if (!itemId || !catalogId || !currentAskPrice || !BidderId || BidderId === -1 || !publishKey) {
            throw new Error('Failed to submit bid-hover-intent, missing critical information');
        }

        return pubnubService.publish(`catalog.${catalogId}.${itemId}`, {
            Amount: currentAskPrice,
            AuctionId: catalogId,
            BidderHasHighBid: hasHighBid,
            BidderId,
            BidSource,
            Created: created,
            Currency: currency,
            EventType: 'bid-hover-intent',
            // TODO: We may add HasBidOnThisTypeOfItemBefore,
            // TODO: We may add HasWonThisTypeOfItemBefore,
            // TODO: We may add HasWonAnyItemBefore,
            // TODO: We may add HasWonItemFromThisSeller,
            IsItemSaved: isSaved,
            IsSellerFollowed: isFollowed,
            LotId: itemId,
        });
    } catch (error) {
        // we dont really care on the client if it doesnt go through
        console.error(error);
    }
};

export const sendDismissHoverMessage = (
    actionTime: number,
    catalogId: number,
    currentAskPrice: number,
    currency: string,
    itemId: number
) => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const created = new Date(actionTime).toISOString();
        const BidderId = getBidderId(state);
        const publishKey = getPubnubPublishKey(state, catalogId);
        const BidSource = getBidSource(state);

        // Throw an error if we are missing info for bidding or the bidderid is -1
        if (!itemId || !catalogId || !currentAskPrice || !BidderId || BidderId === -1 || !publishKey) {
            throw new Error('Failed to submit bid-hover-dismiss, missing critical information');
        }

        return pubnubService.publish(`catalog.${catalogId}.${itemId}`, {
            Amount: currentAskPrice,
            AuctionId: catalogId,
            BidderId,
            BidSource,
            Created: created,
            Currency: currency,
            EventType: 'bid-hover-dismiss',
            LotId: itemId,
        });
    } catch (error) {
        // we dont really care on the client if it doesnt go through
        console.error(error);
    }
};
